
export default {
  name: 'StickyContainer',
};
